import { combineReducers } from 'redux';
import { IinitialState } from '.';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { IdashboardData } from '../models';

export const getDashboardData = (state: IinitialState): IdashboardData => state.dashboard.dashboardData;
export const getDashboardIsLoading = (state: IinitialState): boolean => state.ajaxCallsInProgress > 0;

function dashboardDataReducer(state: IdashboardData = initialState.dashboard.dashboardData, action: any) {
    switch (action.type) {
        case types.GET_FSEDASHBOARD:
            return action.payload;
        default:
            return state;
    }
}

const dashboard = combineReducers({
    dashboardData: dashboardDataReducer
});

export default dashboard;
